<div id="vendor-consent" class="p-2 form-body-wrapper" *ngIf="!consentApproved"
    style="height: calc(100% - 120px);width: 50%;min-width: 400px;margin: auto;">
    <igx-card>
        <igx-card-header class="igx-card-header" style="text-align: center;"> <span class="top-title-header"
                style="font-size:24px;font-weight: 800;text-align: center;">Vendor/Trades
                Consent</span> </igx-card-header>
        <igx-card-content class="gradiant" style="overflow: hidden;padding: 15px;">
            <table>
                <tr class="row">
                    <td class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div style="text-align: justify;padding-bottom: 25px;">
                            <span>You agree to receive SAM messages and information from the SAM Web application at the
                                number
                                provided. Consent is not a condition of purchase. Massage and data rates may apply.
                                Message
                                Frequency varies. Please view our Privacy Policy and Terms.</span>
                        </div>
                    </td>
                </tr>
                <tr class="row">
                    <td>
                        <div class="form-toolbar-btn-wrapper" style="width: 100%;">
                            <div class="form-action-btn" style="padding: 0 5px; text-align: center;">
                                <button [disabled]="tokenExpired" igxButton igxRipple type="submit"
                                    (click)="consentApprove();">Approve Consent
                                </button>
                                <div *ngIf="tokenExpired" class="alert">This link is expired. Please contact to
                                    administrator.</div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </igx-card-content>
    </igx-card>
</div>
<div id="vendor-consent" class="p-2 form-body-wrapper" *ngIf="consentApproved"
    style="height: calc(100% - 120px);width: 50%;min-width: 400px;margin: auto;">
    <igx-card>
        <igx-card-content class="gradiant" style="overflow: hidden;padding: 15px;text-align: center;">
            <span class="top-title-header" style="font-size:24px;font-weight: 800;text-align: center;">Thank you for
                approve a consent.</span>
        </igx-card-content>
    </igx-card>
</div>